import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { GetMoneyValue, getThousandComma } from "../../../../Api/ApiCommon";
import { useApi } from "../../../../hooks/useApi";
import { payTypeString } from "../../../../pages/Pay/PayInfo";
import { Filters, TotalCount } from "../../../../pages/Users/UserInfo";
import LineBtn from "../../../Button/LineBtn";
import ExcelDownload from "../../../DefaultStyles/ExcelDownload";
import LineBox from "../../../DefaultStyles/LineBox";
import Loader from "../../../DefaultStyles/Loader";
import DropDown, { OptionType } from "../../../Filters/DropDown";
import Search from "../../../Filters/Search";
import Pagination from "../../../Table/Pagination";
import Table, { TableBody, TableBodyItem } from "../../../Table/Table";
import CalculatePayFailDetail from "./CalculatePayFailDetail";
import dayjs from "dayjs";
import SpaceBetween from "../../../DefaultStyles/SpaceBetween";
import { atom, useRecoilState } from "recoil";

interface IPayFailLogs {
  amount: number;
  cdname: string;
  charge: number;
  comm: number;
  coupon: number;
  deposit: number;
  money: number;
  point: number;
}

interface IPayFailLog {
  curmoney: number;
  date: string;
  grade: number;
  logdata?: IPayFailLogs;
  log?: IPayFailLogs;
  mcid: string;
  mginfo: {
    commission: number;
    cur: number;
    deposit: number;
    next: number;
    ownerpd: string;
    payd: string;
    reward: number;
    total: number;
  };
  partyid: number;
  reason: number;
  subs: number;
  uid: number;
  pg?: string;
}

interface STableBodyItemChild {
  selected?: boolean;
}

export interface IPayFail {
  id?: string;
  uid: number;
  name: string;
  nickname: string;
  partyid: number;
  servsubsid: number;
  err: string;
  time: string;
  log: IPayFailLog[];
  type: number;
  mcid: string;
  curmoney: string;
  trycount?: number;
  reason?: any;
  phone?: string;
  lastCardChange?: string;
}

export const payFailDropdownState = atom<OptionType>({
  key: "payFailDropdownState",
  default: {
    value: "",
    label: "선택",
  },
});

export const payFailSearchState = atom<string | undefined>({
  key: "payFailSearchState",
  default: "",
});

export const payFailPageState = atom<number>({
  key: "payFailPageState",
  default: 0,
});

export default function CalculatePayFail() {
  const navigate = useNavigate();

  const [savedPage, setSavedPage] = useRecoilState<number>(payFailPageState);
  const [page, setPage] = useState(savedPage);

  useEffect(() => {
    setSavedPage(0);
  }, []);

  const [dropDownValue, setDropDownValue] =
    useRecoilState(payFailDropdownState);
  const [searchValue, setSearchValue] = useRecoilState(payFailSearchState);
  const [btnClick, setBtnClick] = useState(false);
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const [activeDetailIndex, setActiveDetailIndex] = useState<number | null>(
    null
  );

  const [logData, setLogData] = useState<any>({
    cdname: "",
    charge: 0,
    comm: 0,
    coupon: 0,
    deposit: 0,
    money: 0,
    point: 0,
  });

  const { response, loading } = useApi({
    method: "get",
    url:
      `pay/1?page=${page}&size=10&isRefund=0` +
      (searchValue ? `&${dropDownValue?.value}=${searchValue}` : ``),
  });

  const tableHead = [
    "UID_이름_닉네임",
    "실패 이유",
    "PID",
    "적요",
    "금액",
    "결제 실패 일시",
    "보기",
  ];

  const options: OptionType[] = [
    { value: "uid", label: "UID" },
    { value: "name", label: "이름" },
    { value: "nickname", label: "닉네임" },
    { value: "phone", label: "전화번호" },
    { value: "partyid", label: "PID" },
  ];

  useEffect(() => {
    setTimeout(() => {
      setBtnClick(false);
    }, 100);
  }, [page]);

  return (
    <>
      <Filters>
        <DropDown
          isDisabled={false}
          setDropDownValue={setDropDownValue}
          dropdownValue={dropDownValue}
          optionList={options}
        />

        <Search
          placeholder="입력"
          setSearchValue={setSearchValue}
          isDisabled={dropDownValue ? false : true}
          pageResetEvent={() => setPage(0)}
          defaultValue={searchValue !== "" ? searchValue : undefined}
          inputType={
            dropDownValue?.value === "partyid" ||
            dropDownValue?.value === "phone" ||
            dropDownValue?.value === "uid"
              ? "number"
              : undefined
          }
        />
      </Filters>

      <LineBox>
        <Table tableHeadData={tableHead} tableMinWidth={1140}>
          <>
            {response?.data?.items?.map((d: IPayFail, index: number) => {
              return (
                <React.Fragment key={index}>
                  <TableBody>
                    <FailTableBodyItem
                      style={{
                        textDecoration: "underline",
                        cursor: "pointer",
                        verticalAlign: "baseline",
                      }}
                      onClick={() => {
                        setSavedPage(page);
                        navigate(`/users/info/${d?.uid}`);
                      }}
                    >
                      <TableBodyItemChild>
                        {d?.uid}_{d?.name}_{d?.nickname}
                      </TableBodyItemChild>
                    </FailTableBodyItem>

                    <FailTableBodyItem style={{ verticalAlign: "baseline" }}>
                      <TableBodyItemChild>
                        {d?.err}
                        {d?.log[0]?.pg ? ` (${d?.log[0]?.pg})` : ""}
                      </TableBodyItemChild>
                    </FailTableBodyItem>

                    <FailTableBodyItem
                      style={{
                        textDecoration: "underline",
                        cursor: "pointer",
                        padding: 0,
                      }}
                    >
                      {d?.log?.map((data, i: number) => (
                        <TableBodyItemChild
                          key={i}
                          selected={
                            d?.log?.length > 1 &&
                            logData?.partyid === data?.partyid &&
                            btnClick
                          }
                          onClick={() => {
                            setSavedPage(page);
                            navigate(`/party/info/${data?.partyid}`);
                          }
                          }
                        >
                          {data?.partyid}
                        </TableBodyItemChild>
                      ))}
                    </FailTableBodyItem>

                    <FailTableBodyItem style={{ padding: 0 }}>
                      {d?.log?.map((data, i: number) => (
                        <TableBodyItemChild
                          key={i}
                          selected={
                            d?.log?.length > 1 &&
                            logData?.partyid === data?.partyid &&
                            btnClick
                          }
                        >
                          {payTypeString(data?.reason, true)}
                        </TableBodyItemChild>
                      ))}
                    </FailTableBodyItem>

                    <FailTableBodyItem style={{ padding: 0 }}>
                      {d?.log?.map((data, i: number) => (
                        <TableBodyItemChild
                          selected={
                            d?.log?.length > 1 &&
                            logData?.partyid === data?.partyid &&
                            btnClick
                          }
                          style={{
                            fontWeight: "bold",
                          }}
                          key={i}
                        >
                          {GetMoneyValue(data?.logdata?.amount)}
                        </TableBodyItemChild>
                      ))}
                    </FailTableBodyItem>

                    <FailTableBodyItem>
                      {d?.log?.map((data, i: number) => (
                        <TableBodyItemChild
                          key={i}
                          selected={
                            d?.log?.length > 1 &&
                            logData?.partyid === data?.partyid &&
                            btnClick
                          }
                        >
                          {dayjs(d?.time)?.format("YYYY-MM-DD HH:mm")}
                        </TableBodyItemChild>
                      ))}
                    </FailTableBodyItem>

                    <FailTableBodyItem>
                      {d?.log?.map((data, i: number) => {
                        return (
                          <TableBodyItemChild
                            key={i}
                            selected={
                              d?.log?.length > 1 &&
                              logData?.partyid === data?.partyid &&
                              btnClick
                            }
                          >
                            <LineBtn
                              btnText={
                                logData?.partyid === data?.partyid && btnClick
                                  ? "접기"
                                  : "보기"
                              }
                              btnClickEvent={() => {
                                setLogData(data);
                                setActiveIndex(index);
                                setActiveDetailIndex(i);

                                console.log(activeDetailIndex, i);
                                console.log(activeIndex, index);

                                if (d?.log?.length > 1) {
                                  if (activeDetailIndex === i) {
                                    setBtnClick(!btnClick);
                                  } else {
                                    setBtnClick(true);
                                  }
                                } else {
                                  if (activeIndex === index) {
                                    setBtnClick(!btnClick);
                                  } else {
                                    setBtnClick(true);
                                  }
                                }
                              }}
                            />
                          </TableBodyItemChild>
                        );
                      })}
                    </FailTableBodyItem>
                  </TableBody>

                  {activeIndex === index && btnClick && (
                    <CalculatePayFailDetail data={logData} />
                  )}
                </React.Fragment>
              );
            })}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response.data.totalPage : 1}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              response?.status === 200 ? +response?.data?.totalCount : 0
            )}
            개
          </TotalCount>
        </SpaceBetween>
      </LineBox>

      <ExcelDownload
        disabled={false}
        dataUrl={
          `pay/1?page=0&size=1000` +
          (searchValue ? `&${dropDownValue?.value}=${searchValue}` : ``)
        }
        title="정산 결제 실패"
        tableHead={[
          "UID_이름_닉네임",
          "실패 이유",
          "PID",
          "적요",
          "금액",
          "총액",
          "결제 실패 일시",
          "보기",
        ]}
        pushedData={(d: IPayFail) => {
          return [
            `${d?.uid}_${d?.name}_${d?.nickname}`,
            `${d?.err}`,
            `${d?.log?.map((data) => `${data.partyid}`)}`,
            `${d?.log?.map((data) => `${payTypeString(data?.reason, true)}`)}`,
            `${d?.log?.map(
              (data) => `${GetMoneyValue(data?.logdata?.amount)}`
            )}`,
            `${GetMoneyValue(
              d?.log
                .map((o) => o?.logdata?.amount ?? 0)
                .reduce((a: number, c: number) => a + c)
            )}`,
            `${dayjs(d?.time)?.format("YYYY-MM-DD HH:mm")}`,
          ];
        }}
      />

      {loading && <Loader />}
    </>
  );
}

export const FailTableBodyItem = styled(TableBodyItem)`
  padding: 0;
`;

export const TableBodyItemChild = styled.div<STableBodyItemChild>`
  height: 60px;
  display: flex;
  align-items: center;
  padding: 0px 10px;
  background-color: ${({ selected }) => (selected ? "#f5f5f5" : "white")};

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.buttonColor.lineNormal};
  }
`;
